import QRCode from 'qrcode.react';
import React, { useRef } from 'react';
import Button from '@dashboard/components/Button';
import downloadUrlAsFile from '@dashboard/services/downloadUrlAsFile';
import getCheckoutUrl from '@dashboard/services/getCheckoutUrl';

const CheckoutShareQRCode = ({ page, seller }) => {
  const largeQrParentRef = useRef(null);

  const pageUrlId = page.slug;
  const checkoutUrl = getCheckoutUrl(page, seller);
  const qrUrl = `${checkoutUrl}/qr`;

  const downloadQrCode = () => {
    const qrCodeUrl = largeQrParentRef?.current?.firstChild
      ?.toDataURL('image/png')
      .replace('image/png', 'image/octet-stream');

    downloadUrlAsFile(qrCodeUrl, pageUrlId + '-qrcode.png');
  };

  return (
    <div className="flex flex-col">
      <div className="mx-auto rounded bg-white p-4">
        <QRCode value={checkoutUrl} size={200} />
      </div>

      {/* Hidden large QR code for downloading */}
      <div
        style={{ visibility: 'hidden', display: 'none', position: 'absolute', top: 0, left: 0 }}
        ref={largeQrParentRef}
      >
        <QRCode value={checkoutUrl} size={1800} />
      </div>

      <div className="flex justify-center w-full">
        <Button
          appearance=""
          className="pt-0 pb-0 pl-0 pr-0 flex items-center"
          onClick={downloadQrCode}
        >
          <span className="underline">Download</span>
        </Button>

        <Button
          to={qrUrl}
          target="_blank"
          appearance=""
          className="ml-4 pt-0 pb-0 pl-0 pr-0 flex items-center"
        >
          <span className="underline">Open in new tab</span>
        </Button>
      </div>
    </div>
  );
};

export default CheckoutShareQRCode;
